import React, { useEffect, forwardRef, useState } from 'react';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
} from '@mui/x-data-grid';

import moment from "moment";
import "moment/locale/es";

import Loader from "components/Loader/Loader";

import { Redirect } from 'react-router-dom';

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
    { id: 'IdCuenta', label: 'IdCuenta', minWidth: 100 },
    { id: 'NombreCliente', label: 'Nombre Cliente', minWidth: 100 },
    { id: 'Telefono', label: 'Telefono', minWidth: 100 },
    { id: 'Correo', label: 'Correo', minWidth: 100 },
    { id: 'NombreCapturista', label: 'Capturista', minWidth: 100 },
    { id: 'FechaCapturista', label: 'Fecha Captura', minWidth: 100 }
];

function Captura(){
    const [capturas, setCapturas] = useState([]);
    const [Estatus, setEstatus] = useState([]);
    const [GruposVulnerables, setGruposVulnerables] = useState([]);

    const [color, setColor] = useState("");
    const [message, setMessage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [load, setLoad] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogComment, setOpenDialogComment] = useState(false);

    const [IdCaptura, setIdCaptura] = useState("");
    const [IdCuenta, setIdCuenta] = useState("");

    const [NombreCliente, setNombreCliente] = useState("");
    const [Producto, setProducto] = useState("");
    const [UltimosDigitos, setUltimosDigitos] = useState("");
    const [FechaCobro, setFechaCobro] = useState("");
    const [AltaRenovacion, setAltaRenovacion] = useState("");

    const [Correo, setCorreo] = useState("");
    const [RFC, setRFC] = useState("");
    const [Edad, setEdad] = useState("");
    const [Telefono, setTelefono] = useState("");
    const [CanalVenta, setCanalVenta] = useState("");
    const [FinPrograma, setFinPrograma] = useState("");
    const [FechaInformacion, setFechaInformacion] = useState("");
    const [MesesRestantes, setMesesRestantes] = useState("");
    const [MontoCobrado, setMontoCobrado] = useState("");
    const [LineaCredito, setLineaCredito] = useState("");
    const [FechaCorte, setFechaCorte] = useState("");

    const [ProgramaLealtad, setProgramaLealtad] = useState("");
    const [NombreAdicional, setNombreAdicional] = useState("");
    const [ProgramaCero, setProgramaCero] = useState("");
    const [Acelerador, setAcelerador] = useState("");
    const [PerfilCliente, setPerfilCliente] = useState("");

    const [IdEstatus, setIdEstatus] = useState("1");
    const [IdGruposVulnerables, setIdGruposVulnerables] = useState("1");

    const [EsICR, setEsICR] = useState("");
    const [FolioCancelacion, setFolioCancelacion] = useState("");

    const [tipo, setTipo] = useState('rfc');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);

    const [RFCError, setRFCError] = useState(false);

    const [Comentarios, setComentarios] = useState([]);
    const [TextoModal, setTextoModal] = useState("");
    const [Comentario, setComentario] = useState("");
    const [IdCapturaComentarios, setIdCapturaComentarios] = useState(0);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const columnsComments = [
    { field: 'Comentario', headerName: 'Comentario', width: 220, editable: false },
    { field: 'FechaComentario', headerName: 'Fecha Comentario', width: 180, editable: true },    
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 150,
        cellClassName: 'actions',
        getActions: ({row}) => {
            const fechaFila = moment(row.FechaComentario, 'DD-MM-YYYY HH:mm:ss');
        
            const esHoy = fechaFila.isSame(moment(), 'day');

            if (!esHoy) {
                return [];
            }

            return [
                <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={EditarComentario(row)}
                color="inherit"
                key="edit"
                />,
                <GridActionsCellItem
                icon={<DeleteIcon />}
                label="Eliminar"
                onClick={EliminarComentario(row)}
                color="inherit"
                key="eliminar"
                />
            ];
        },
    },
    ];

    const AgregarComentario = () => {
        limpia();
        setOpenDialogComment(true);
        setTextoModal("Agregar Comentario");
    };

    function EditToolbar(props) {  
        return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={AgregarComentario}>
                Agregar Comentario
            </Button>
        </GridToolbarContainer>
        );
    }

    const EditarComentario = (row) => () => {
        limpia();
        llenar(row);
        setOpenDialogComment(true);
        setTextoModal("Editar Comentario");
    };

    const EliminarComentario = (row) => () => {
        limpia();
        llenar(row);
        setOpenDialogComment(true);
        setTextoModal("Eliminar Comentario");
    };

    const limpia = () => {
        setComentario("");
        setIdCapturaComentarios(0);
    };

    const llenar = (row) => {
        setComentario(row.Comentario);
        setIdCapturaComentarios(row.IdCapturaComentarios);
    };

    const AceptarModalComentario = () => {
        setLoad(true);

        if(IdCaptura === ""){
            sendSnackBar("Debes seleccionar una registro", "error");
            setLoad(false);
            return;
        }

        let datos = {
            IdCapturaComentarios: parseInt(IdCapturaComentarios),
            IdCaptura: parseInt(IdCaptura),
            Comentario,
        };

        Login()
        .then(result => {
            let token = result.token;

            if(TextoModal === "Agregar Comentario"){
                InsertaCapturaComentarios(datos, token)
                .then(response => {
                    if(response.success){
                        sendSnackBar("Comentario agregado correctamente", "success");
                        ObtieneCapturaComentarios(token, { IdCaptura: parseInt(IdCaptura) })
                        .then(result => {
                            let comentarios = result.comentarios.map((element) => {
                                element.id = Math.random() * 10;
                                element.FechaComentario = element.FechaComentario === "" ? "" : moment(moment(element.FechaComentario, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");

                                return element;
                            });
                            setComentarios(comentarios);
                        });
                    } else {
                        sendSnackBar("Error al agregar comentario", "error");
                    }
                    setLoad(false);
                });
            } else if(TextoModal === "Editar Comentario") {
                ActualizaCapturaComentarios(datos, result.token)
                .then(response => {
                    if(response.success){
                        sendSnackBar("Comentario actualizado correctamente", "success");
                        ObtieneCapturaComentarios(token, { IdCaptura: parseInt(IdCaptura) })
                        .then(result => {
                            let comentarios = result.comentarios.map((element) => {
                                element.id = Math.random() * 10;
                                element.FechaComentario = element.FechaComentario === "" ? "" : moment(moment(element.FechaComentario, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");

                                return element;
                            });
                            setComentarios(comentarios);
                        });
                    } else {
                        sendSnackBar("Error al actualizar comentario", "error");
                    }
                    setLoad(false);
                });
            } else {
                EliminaCapturaComentarios(datos, result.token)
                .then(response => {
                    if(response.success){
                        sendSnackBar("Comentario eliminado correctamente", "success");
                        ObtieneCapturaComentarios(token, { IdCaptura: parseInt(IdCaptura) })
                        .then(result => {
                            let comentarios = result.comentarios.map((element) => {
                                element.id = Math.random() * 10;
                                element.FechaComentario = element.FechaComentario === "" ? "" : moment(moment(element.FechaComentario, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");

                                return element;
                            });
                            setComentarios(comentarios);
                        });
                    } else {
                        sendSnackBar("Error al eliminar comentario", "error");
                    }
                    setLoad(false);
                });
            }
        });

        setOpenDialogComment(false);
    };

    const getUser = () => {
        return JSON.parse(localStorage.getItem("userRetencion")).IdUsuario;
    };

    const sendSnackBar = (pmessage, pcolor) => {
        setOpenSnackbar(true);
        setColor(pcolor);
        setMessage(pmessage);
    };

    const selectRow = (e, row) => {
        e.stopPropagation(); 
        e.preventDefault();

        let elemento = capturas.map(element => {
            if(element.IdCaptura === row.IdCaptura)
            {
                element.select = true;
                return element;
            }
            else
            {
                element.select = false;
                return element;
            }
        });

        setCapturas(elemento);
        limpiaValores();

        let cap = elemento.find(item => item.IdCaptura === row.IdCaptura);

        setIdCaptura(cap.IdCaptura);
        setIdCuenta(cap.IdCuenta)

        setNombreCliente(cap.NombreCliente);
        setProducto(cap.Producto);
        setUltimosDigitos(cap.UltimosDigitos);
        setFechaCobro(cap.FechaCobro);
        setAltaRenovacion(cap.AltaRenovacion);

        setCorreo(cap.Correo);
        setRFC(cap.RFC);
        setEdad(ObtenerEdadDesdeRFC(cap.RFC));
        setTelefono(cap.Telefono);
        setCanalVenta(cap.CanalVenta);
        setFinPrograma(cap.FinPrograma);
        setFechaInformacion(cap.FechaInformacion);
        setMesesRestantes(cap.MesesRestantes);
        setMontoCobrado(cap.MontoCobrado);
        setLineaCredito(cap.LineaCredito);
        setFechaCorte(cap.FechaCorte);
        
        let estatus = Estatus.find(item => item.IdEstatus === cap.IdEstatus);
        setIdEstatus(estatus ? estatus.IdEstatus : 60);
        setIdGruposVulnerables(cap.IdGruposVulnerables);
        
        setEsICR(cap.EsICR);
        setFolioCancelacion(cap.FolioCancelacion);
        setProgramaLealtad(cap.ProgramaLealtad);
        setNombreAdicional(cap.NombreAdicional);
        setProgramaCero(cap.ProgramaCero);
        setAcelerador(cap.Acelerador);
        setPerfilCliente(cap.PerfilCliente);

        Login()
        .then(result => {
            let token = result.token;

            ObtieneCapturaComentarios(token, { IdCaptura: parseInt(cap.IdCaptura) })
            .then(result => {
                let comentarios = result.comentarios.map((element) => {
                    element.id = Math.random() * 10;
                    element.FechaComentario = element.FechaComentario === "" ? "" : moment(moment(element.FechaComentario, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");

                    return element;
                });
                setComentarios(comentarios);
            });
        });
    };

    const tipoNumero = (valor) => {
        let num = 0;

        switch(valor)
        {
            case "rfc":
                num = 1;
                break;
            case "telefono":
                num = 2;
                break
            case "correo":
                num = 3;
                break
            case "nombre":
                num = 4;
                break
        }

        return num;
    };

    const buscar = (event) => {
        event.preventDefault();
        setLoad(true);

        limpiaValores();

        let busqueda = document.getElementById("busqueda").value;

        if(busqueda !== ""){
            Login()
            .then(result => {
                if(result !== undefined){
                    let params = {
                        Indicador: busqueda,
                        Tipo: tipoNumero(tipo),
                        Capturista: getUser()
                    };
    
                    ObtieneCapturasCapturistas(result.token, params)
                    .then(result => {
                        let capturas = result.capturas.map((element) => {
                            element.FechaCobro = element.FechaCobro === "" ? "" : moment(moment(element.FechaCobro, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY");
                            element.FinPrograma = element.FinPrograma === "" ? "" : moment(moment(element.FinPrograma, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY");
                            element.FechaInformacion = element.FechaInformacion === "" ? "" : moment(moment(element.FechaInformacion, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY");
                            element.FechaCorte = element.FechaCorte === "" ? "" : moment(moment(element.FechaCorte, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY");
                            element.FechaCapturista = element.FechaCapturista === "" ? "" : moment(moment(element.FechaCapturista, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");
                            return element;
                        });
                        setCapturas(capturas);
                        setLoad(false);
    
                    }).catch(error => sendSnackBar("Error de conexión", "error"));
                } else {
                    sendSnackBar("Error de conexión", "error");
                }
            }).catch(error => sendSnackBar("Error de conexión", "error"));
        } else {
            sendSnackBar("Debes agregar un elemento a buscar", "error");
            setLoad(false);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const SnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenSnackbar(false);
    };

    const DialogClose = () => {
        setOpenDialog(false);
        setTimeout(function(){ window.location.reload(false); }, 1000);
    };

    const Login = async () => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
                headers: {
                    "Content-Type": "application/json"
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Login",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    const ActualizaCaptura = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/ActualizaCaptura",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneCapturasCapturistas = async (token, data) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/ObtieneCapturasCapturistas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneGruposVulnerables = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Estatus/ObtieneGruposVulnerables",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneEstatusGrupo = async (token, data) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Estatus/ObtieneEstatusGrupo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneCapturaComentarios = async (token, data) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/ObtieneCapturaComentarios",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const InsertaCapturaComentarios = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/InsertaCapturaComentarios",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ActualizaCapturaComentarios = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/ActualizaCapturaComentarios",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const EliminaCapturaComentarios = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/EliminaCapturaComentarios",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ValidaDatos = () => {
        let fecha = moment(Date.now());
        let folio_cancelacion = '';

        let regex = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([A-Z0-9]{3})?$/;
        if(RFC === "" || regex.test(RFC.trim().toUpperCase()) === false){
            setRFCError(true);
            return { error: "RFC inválido" };
        }

        if(IdEstatus === 3 || IdEstatus === 4 || IdEstatus === 6 || IdEstatus === 16){
            folio_cancelacion = 'C' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        if(IdEstatus === 36 || IdEstatus === 52){
            folio_cancelacion = 'CC' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        if(IdEstatus === 37){
            folio_cancelacion = 'CB' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        let datos = { IdCaptura: parseInt(IdCaptura), IdGrupo: 0, IdEstatus: parseInt(IdEstatus), 
            IdSubEstatus: 0, IdEstatusCargo: 0, IdGruposVulnerables: parseInt(IdGruposVulnerables), 
            FechaCapturista: fecha.toDate(), Capturista: getUser(), FolioCancelacion: folio_cancelacion, CanalVenta };
        
        return datos;
    }

    const EnviaDatos = () => {
        try{
            setLoad(true);
            
            let datos = ValidaDatos();
            if(datos.error === undefined && IdCaptura !== "" && Comentarios.length > 0){
                Login()
                .then(result => {
                    if(result !== undefined){
                        ActualizaCaptura(datos, result.token)
                        .then(result => {
                            if(result.success){
                                sendSnackBar("Registro exitoso", "success");
                                setOpenSnackbar(true);
                                setOpenDialog(true);
                            } else {
                                sendSnackBar("Error de conexión", "error");
                            }
            
                            setLoad(false);
                        }).catch(error => sendSnackBar("Error de conexión", "error"));
                    } else {
                        sendSnackBar("Error de conexión", "error");
                        setLoad(false);
                    }
                }).catch(error => sendSnackBar("Error de conexión", "error"));
            } else {
                sendSnackBar("Todos los valores son obligatorios", "error");
                setLoad(false);
            }
        } catch(error){
            sendSnackBar("Error de conexión", "error");
            setLoad(false);
        }
    };

    const limpiaValores = () => {
        setIdCaptura("");
        setIdCuenta("")

        setNombreCliente("");
        setProducto("");
        setUltimosDigitos("");
        setFechaCobro("");
        setAltaRenovacion("");

        setCorreo("");
        setRFC("");
        setTelefono("");
        setCanalVenta("");
        setFinPrograma("");
        setFechaInformacion("");
        setMesesRestantes("");
        setMontoCobrado("");
        setLineaCredito("");
        setFechaCorte("");

        setIdEstatus(Estatus[0] ? Estatus[0].IdEstatus : 60);
        setIdGruposVulnerables(GruposVulnerables[0] ? GruposVulnerables[0].IdGruposVulnerables : 1);
        setEsICR("");
        setFolioCancelacion("");

        setProgramaLealtad("");
        setNombreAdicional("");
        setProgramaCero("");
        setAcelerador("");
        setPerfilCliente("");
    };

    const UsuarioActivo = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    const GetIdUsuario = () => {
        return JSON.parse(localStorage.getItem('userRetencion')).IdUsuario;
    };

    const OnChangeEstatus = (value) => {
        setIdEstatus(value);
        setIdGruposVulnerables(GruposVulnerables[0].IdGruposVulnerables);
    };

    const ObtenerEdadDesdeRFC = (rfc) => {
        const rfcLimpio = rfc.trim().toUpperCase();

        const anioCorto = parseInt(rfcLimpio.substring(4, 6), 10);
        const mes = parseInt(rfcLimpio.substring(6, 8), 10) - 1;
        const dia = parseInt(rfcLimpio.substring(8, 10), 10);

        const anioActualCorto = new Date().getFullYear() % 100;
        const anioCompleto = anioCorto > anioActualCorto ? 1900 + anioCorto : 2000 + anioCorto;

        const fechaNacimiento = new Date(anioCompleto, mes, dia);
        const hoy = new Date();

        let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
        const diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();

        if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
            edad--;
        }

        return edad;
    };

    const OnChangeRFC = (value) => {
        setRFC(value.trim().toUpperCase());

        let regex = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([A-Z0-9]{3})?$/;
        if(regex.test(value.trim().toUpperCase())){
            setRFCError(false);
            setEdad(ObtenerEdadDesdeRFC(value));
        } else {
            setRFCError(true);
            setEdad("");
        }
    };

    useEffect(() => {
        Login()
        .then(result => {
            let token = result.token;

            UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
            .then(result => {
                if(result.activo === false){
                    localStorage.removeItem("userRetencion");
                    return <Redirect to='/admin'/>;
                }
            });

            ObtieneGruposVulnerables(token)
            .then(result => {
                setGruposVulnerables(result.gruposVulnerables);
            });

            ObtieneEstatusGrupo(token, { IdGrupo: 0 })
            .then(result => {
                setEstatus(result.estatus);
                let idEstatus = result.estatus[0].IdEstatus;
                setIdEstatus(idEstatus);
            });
        });
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={6} xl={6}>
                    <Paper
                        style={{ marginBottom: "30px" }}
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                        >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Buscar..."
                            inputProps={{ 'aria-label': 'search google maps' }}
                            id="busqueda"
                        />
                        <IconButton onClick={buscar} sx={{ p: '10px' }} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} xl={6}>
                    <FormControl component="fieldset">
                        <RadioGroup row aria-label="gender" name="row-radio-buttons-group">
                            <FormControlLabel
                                checked={tipo === 'rfc'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="rfc" 
                                control={<Radio />} 
                                label="RFC" />
                            <FormControlLabel
                                checked={tipo === 'telefono'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="telefono" 
                                control={<Radio />} 
                                label="Teléfono" />
                            <FormControlLabel
                                checked={tipo === 'correo'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="correo" 
                                control={<Radio />} 
                                label="Correo" />
                            <FormControlLabel
                                checked={tipo === 'nombre'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="nombre" 
                                control={<Radio />} 
                                label="Nombre" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                { capturas.length > 0 && 
                    (
                        <Grid item xs={12} sm={12} xl={12} style={{ marginBottom: "30px" }}>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 440 }}>
                                    <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                        {columns.map((column, index) => (
                                            <TableCell
                                                key={index}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {capturas.map((row, index) => {
                                            return (
                                                <TableRow onClick={(e) => selectRow(e, row)} selected={row.select} hover={true} tabIndex={-1} key={index}>
                                                    {columns.map((column, ind) => {
                                                        return (
                                                            <TableCell key={ind} align={column.align}>
                                                                {  
                                                                    row[column.id]
                                                                }
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={capturas.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(event, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Grid>
                    )
                }
            </Grid>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Referencia
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={IdCuenta} disabled={true} label="Id Cuenta" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                </Grid>
            </Card>       
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Datos cliente
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={NombreCliente} disabled={true} label="Nombre del cliente" variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Producto} disabled={true} label="Producto" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={UltimosDigitos} disabled={true} label="Últimos 6 dígitos" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={FechaCobro} disabled={true} label="Fecha de cobro" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={AltaRenovacion} disabled={true} label="Alta renovacion vigente" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={EsICR} disabled={true} label="*" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Autenticación
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Correo} disabled={true} label="Correo" type="email" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="RFC" value={RFC} onChange={(event) => OnChangeRFC(event.target.value)} inputProps={{ maxLength: 13 }} variant="outlined" style={{ width: "100%" }} error={RFCError} required />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Edad" value={Edad} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Teléfono" disabled={true} value={Telefono} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Retención
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={CanalVenta} onChange={(event) => setCanalVenta(event.target.value)} label="Canal de venta" inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Fin programa cero" value={FinPrograma} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Fecha informacion" value={FechaInformacion} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Meses restantes con P0" value={MesesRestantes} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Monto cobrado" value={MontoCobrado} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Linea de credito" disabled={true} value={LineaCredito} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Fecha corte" value={FechaCorte} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Estatus
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Estatus*"
                            value={IdEstatus} 
                            onChange={(event) => OnChangeEstatus(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {Estatus.map((option) => (
                                <MenuItem key={option.IdEstatus} value={option.IdEstatus}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Grupos Vulnerables*"
                            value={IdGruposVulnerables} 
                            onChange={(event) => setIdGruposVulnerables(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {GruposVulnerables.map((option) => (
                                <MenuItem key={option.IdGruposVulnerables} value={option.IdGruposVulnerables}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Folio Cancelación" value={FolioCancelacion} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12}>
                        <DataGrid
                            rows={Comentarios}
                            columns={columnsComments}
                            slots={{
                                toolbar: EditToolbar,
                            }}
                            sx={{
                                '& .MuiInputBase-root':
                                {
                                    padding: '10px 30px 10px 0 !important',
                                    width: 'auto !important'
                                },
                                '& .MuiInputBase-root svg':
                                {
                                    display: 'block',
                                    width: '2em',
                                    height: '2em',
                                    top: 'calc(50% - 1em)'
                                },
                                '& .MuiSelect-select':
                                {
                                    width: '100% !important',
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Extras
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Programa Lealtad" value={ProgramaLealtad} disabled={true} inputProps={{ maxLength: 45 }} variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Nombre Adicional" value={NombreAdicional} disabled={true} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Programa Cero" value={ProgramaCero} disabled={true} inputProps={{ maxLength: 10 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Acelerador" value={Acelerador} disabled={true} inputProps={{ maxLength: 10 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Perfil Cliente" value={PerfilCliente} disabled={true} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                </Grid>
            </Card>
            <Grid container
                direction="row-reverse"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={12} sm={12} xl={3}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={EnviaDatos}
                        style={{ float: "right" }}
                        size="large"
                        >
                            { "Enviar" }
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={openDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={DialogClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Registro exitoso"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                         <Typography variant="body1" gutterBottom>
                            {`Referencia: ${IdCuenta}`}
                         </Typography>
                        {
                            FolioCancelacion !== '' ?
                            <Typography variant="body1" gutterBottom>
                                {'Folio de cancelación: ' + FolioCancelacion}
                            </Typography> 
                            : null
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={DialogClose}>Aceptar</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                fullScreen={fullScreen}
                open={openDialogComment}
                onClose={() => setOpenDialogComment(false)}
                aria-labelledby="dialog"
            >
            <DialogTitle id="dialog">
                {TextoModal}
            </DialogTitle>
            <DialogContent>
                <Grid item xs={12} sm={12} xl={12} style={{ marginBottom: "10px", paddingTop: "10px" }}>
                    <TextField label="Comentario" value={Comentario} onChange={(event) => setComentario(event.target.value)} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => setOpenDialogComment(false)}>
                Cancelar
                </Button>
                <Button onClick={AceptarModalComentario} autoFocus>
                Aceptar
                </Button>
            </DialogActions>
            </Dialog>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={SnackbarClose} autoHideDuration={6000}>
                <Alert onClose={SnackbarClose} severity={color} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <Loader load={load} />
        </>
    );
}

export default Captura;